import { SELECT_LOOKUP, TEXT_FIELD, NUMBER_FIELD, DATE, HIDDEN } from '../InputTypes';

export const fields = [
  'CourseName',
  'CourseHrLocationName',
  'CourseLength',
  'CoursePeriodBegda',
  'CoursePeriodEnda',
];

export const detailFields = [
  'CourseName',
  'CourseTypeName',
  'CourseGroupName',
  'CourseHrLocationName',
  'HrRoomName',
  'CourseLength',
  'CourseDescription',
  'Comments',
  'CoursePeriodBegda',
  'CoursePeriodEnda',
  'CoursePoints',
];

export const entityMap = {
  EmployeeMasterID: {
    type: HIDDEN,
  },
  EmployeeMasterCourseID: {
    type: HIDDEN,
  },
  CourseLength: {
    type: NUMBER_FIELD,
  },
  CourseName: {
    type: TEXT_FIELD,
  },
  CourseDescription: {
    type: TEXT_FIELD,
  },
  Comments: {
    type: TEXT_FIELD,
  },
  CoursePoints: {
    type: HIDDEN,
  },
  HrRoomID: {
    type: SELECT_LOOKUP,
    lookup: {
      entity: 'HrRoom',
      value: 'HrRoomID',
      label: 'HrRoomName',
    },
  },
  HrLocationID: {
    type: SELECT_LOOKUP,
    lookup: {
      entity: 'HrLocation',
      value: 'HrLocationID',
      label: 'HrLocationName',
    },
  },
  CourseType: {
    type: SELECT_LOOKUP,
    lookup: {
      entity: 'HrCourseType?$filter=Disabled eq false',
      value: 'CourseType',
      label: 'CourseTypeName',
    },
  },
  CourseGroupID: {
    type: SELECT_LOOKUP,
    lookup: {
      entity: 'HrCourseGroup?$filter=Disabled eq false',
      value: 'HrCourseGroupID',
      label: 'HrCourseGroupName',
    },
  },
  CoursePeriodBegda: {
    type: DATE,
  },
  CoursePeriodEnda: {
    type: DATE,
  },
};



// WEBPACK FOOTER //
// ./src/constants/fields/EmployeeMasterCourse.js